/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconVerticalMenu12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconVerticalMenu12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M7 2.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM6 10.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconVerticalMenu16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconVerticalMenu16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M9.334 3a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0ZM9.334 8a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0ZM8 14.333a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconVerticalMenu20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconVerticalMenu20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M11.666 3.75a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0ZM11.666 10a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0ZM10 17.917a1.667 1.667 0 1 0 0-3.334 1.667 1.667 0 0 0 0 3.334Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconVerticalMenu24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconVerticalMenu24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M14 4.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM12 21.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconVerticalMenu = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconVerticalMenu(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '12':
            return <IconVerticalMenu12 {...iconProps} />;
        case '16':
            return <IconVerticalMenu16 {...iconProps} />;
        case '20':
            return <IconVerticalMenu20 {...iconProps} />;
        case '24':
            return <IconVerticalMenu24 {...iconProps} />;
        default:
            return <IconVerticalMenu24 {...iconProps} />;
    }
});
